import type { FIXED_INDENTS } from 'vars/fixed-indents'
import type { LAYOUT } from 'vars/layout-settings'

import { styled } from '@linaria/react'
import { COLOR } from 'vars/color'

export const SkeletonSC = styled.div<{
  pageBackgroundColor?: COLOR
  componentsBackgroundColor: COLOR
  horizontalLayoutOffsets: LAYOUT | FIXED_INDENTS
  height?: string
  minHeight?: string
  margins?: FIXED_INDENTS[]
}>`
  min-height: ${({ minHeight }) => minHeight || '100vh'};
  min-height: ${({ minHeight }) => minHeight || '-webkit-fill-available'};
  --horizontalPaddings: ${({ horizontalLayoutOffsets }) =>
    `var(${horizontalLayoutOffsets})`};
  height: ${({ height }) => height || '100%'};
  background-color: ${({ pageBackgroundColor }) =>
    pageBackgroundColor ? `var(${pageBackgroundColor})` : 'unset'};
  --componentsBGColor: ${({ componentsBackgroundColor }) =>
    `var(${componentsBackgroundColor})`};
  padding-inline: ${({ horizontalLayoutOffsets }) =>
    horizontalLayoutOffsets ? `var(${horizontalLayoutOffsets})` : 0};
  margin: ${({ margins }) =>
    margins && margins.length > 0
      ? margins.map((item) => `var(${item})`)?.join(' ')
      : 0};

  & *:empty {
    background: var(${COLOR.SKELETON_SHINE_GRADIENT}), var(--componentsBGColor);
    background-repeat: repeat-y;
    background-size: 800px 850px;
    background-position: -800px 0;
    animation: shine 1.5s infinite;
    @keyframes shine {
      to {
        background-position: calc(100vw + 1200px) 0;
      }
    }
  }
`
export const MainPageSkeletonSC = styled.div<{ gap: FIXED_INDENTS }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => `var(${gap})`};
  overflow: hidden;
`
